// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-0e57effc]:export {\n  sideBarWidth: 210px;\n  appHeaderHeight: 60px;\n  interval: 16px;\n}\n.smart-title h2[data-v-0e57effc] {\n  font-size: 36px;\n  color: rgba(0, 0, 0, 0.85);\n  font-weight: 500;\n  line-height: 50px;\n  width: 1280px;\n  margin: 0 auto;\n  text-align: center;\n}\n.smart-title p[data-v-0e57effc] {\n  font-size: 20px;\n  color: hsla(0, 0%, 100%, 0.65) !important;\n  font-weight: 400;\n  line-height: 28px;\n  text-align: center;\n}\n", ""]);
// Exports
module.exports = exports;
